import { useEffect, RefObject } from "react";

type OnClickDocumentProps<T extends HTMLElement> = {
    onClick: (e: MouseEvent) => void;
    refObj: RefObject<T>;
};

export const OnClickDocument = <T extends HTMLElement>(props: OnClickDocumentProps<T>): React.ReactElement => {
    const onDocumentClick = (e: MouseEvent): void => {
        if(props.refObj.current!.contains(e.target as HTMLElement)){
            return;
        }

        props.onClick(e);
    };

    const onUnmount = (): void => {
        document.removeEventListener("click", onDocumentClick, {capture: true});
    };

    const onMount = (): () => void => {
        document.addEventListener("click", onDocumentClick, {capture: true});
        return onUnmount;
    };

    useEffect(onMount, []);

    return <></>;
};